
<template lang="pug">
  .input.input--select
    v-select(
      :options="options"
      :clearable="false"
      :placeholder="defaultOption"
      :value="currentOption"
      @input="handleChange"
    )
    icon(v-if="mobile" name="chevron-down" size="15px")
    select(v-if="mobile" v-model="currentValue", :disabled="disabled")
      option(v-if="!required", value="") {{ defaultOption }}
      option(v-for="option in options", :value="option.value", :key="option.value") {{ option.label }}
</template>

<script>
  import TextInput from '../forms/TextInput.vue'
  import vSelect from 'vue-select';
  import Icon from '../basic/Icon.vue'

  export default {
    name: 'SelectInput',
    extends: TextInput,
    components: {
      vSelect,
      Icon
    },
    props: {
      options: {
        type: Array
      },
      required: {
        type: Boolean,
        default: false
      },
      selected: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      defaultOption () {
        return (this.placeholder !== '') ? this.placeholder : ''
      },

      currentOption () {
        return this.options.filter(opt => opt.value === this.currentValue)[0] || null;
      },

      mobile () {
        return this.$mq === 'mobile';
      }
    },
    watch: {
      currentValue (p, c) {
        this.$emit('input', this.currentValue)
      }
    },
    created () {
      if (this.required && this.currentValue === '' && this.options.length > 0) {
        this.currentValue = this.options[0].value
        this.$emit('input', this.currentValue)
      }
      if ( this.selected !== '' ) {
        let selected = {value: this.selected}
        this.handleChange(selected)
      }
    },
    methods: {
      handleChange (e) {
        this.currentValue = e.value
      }
    }
  }
</script>
<style scoped lang="scss">
  .input {
    position: relative;
  }

  .icon {
    position: absolute;
    top: 50%;
    right: 12px;
    z-index: 1;
    transform: translateY(-50%);
    pointer-events: none;
  }

  select {
    padding: 12px 30px 12px 12px;
    width: 100%;
    border-radius: 4px;
    -webkit-appearance: none;
  }
</style>